var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"jobs"}},[_c('base-section-heading',{attrs:{"title":"Sección en Desarrollo"}},[_vm._v(" Estamos trabajando en el contenido de esta sección. Muy pronto estará operativa. ")]),_c('v-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }